import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { FiArrowUpRight } from "react-icons/fi";
import { playground_icon } from "../../Constants/Data";
import CricketIndividualSkeleton from "../../Components/Skeleton/Cricket/CricketIndividualSkeleton";

function ExternalMatchView() {
    const { id } = useParams();
    const [matchData, setMatchData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [ifBigMatch, setIfBigMatch] = useState(false);

    useEffect(() => {
        const fetchMatchDetails = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_URL}/api/external-matches/${id}`
                );

                console.log(response);
                setMatchData(response.data.match_data);
                setIfBigMatch(response.data.external_match.is_show_home_big_match ?? false);
            } catch (err) {
                console.error("Error fetching match details:", err);
                setError("Failed to load match details.");
            } finally {
                setLoading(false);
            }
        };

        fetchMatchDetails();
    }, [id]);

    if (loading) return <CricketIndividualSkeleton />;
    if (error) return <div className="text-center py-20 text-red-600">{error}</div>;
    if (!matchData) return <div className="text-center py-20">No match data found.</div>;

    const { match, ended_innings } = matchData;
    const team1 = match;
    // API structure: match.team1_name, match.team2_name etc. 

    const formatTime = (timeString) => {
        if (!timeString) return "";
        const [hours, minutes] = timeString.split(":").map(Number);
        const date = new Date();
        date.setHours(hours, minutes);
        return date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
    };

    return (
        <div className="bg-[#F9F9F9] min-h-screen font-Rubik">
            <div className="bg-header-gradient h-[144px] "></div>
            {/* Breadcrumb & Title */}
            <div className="bg-[#EFEFEF] px-[16px] md:px-[24px] py-[24px]">
                <div className="container mx-auto flex flex-col gap-[12px]">
                    <div className="flex gap-[8px] items-center text-[14px] md:text-[18px] text-[#4D4D4D]">
                        {/* <Link to="/">
                            <div className="flex gap-1 items-center hover:text-[#9E120E]">
                                <h3>HOME</h3> <FiArrowUpRight />
                            </div>
                        </Link>
                        <Link to="/all-matches">
                            <div className="flex gap-1 items-center hover:text-[#9E120E]">
                                <h3>MATCHES</h3> <FiArrowUpRight />
                            </div>
                        </Link> */}
                        {/* <h3 className="text-[#9E120E] uppercase underline truncate w-[150px] md:w-auto">
                            {match.match_name || match.series_name}
                        </h3> */}
                    </div>
                    <h2 className="text-[#9E120E] uppercase text-[24px] md:text-[40px] font-medium italic">
                        {match.match_name || match.series_name}
                    </h2>
                </div>
            </div>

            <div className="container mx-auto px-[16px] md:px-0 py-[32px] flex flex-col gap-[32px]">

                {/* Match Header Card */}
                <div className="bg-white rounded-[12px] shadow-sm border border-gray-200 p-[24px] flex flex-col gap-[24px]">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-[16px] gap-4">
                        <div>
                            <h3 className="text-[#4D4D4D] font-medium text-[18px] uppercase">
                                {match.series_name} <br/>
                                {match.match_status_text}
                            </h3>
                            <div className="flex items-center gap-[6px] text-[#2F2F2F] mt-1 text-[14px]">
                                <img src={playground_icon} alt="" className="h-[16px]" />
                                <span>{match.ground_name}</span>
                                <span>•</span>
                                <span>{new Date(match.match_date).toLocaleDateString()}</span>
                            </div>
                        </div>
                        {/* <div className="flex items-center gap-4">
                            <div className={`px-4 py-2 rounded-lg text-white font-medium uppercase text-sm ${match.updated_way === 'LIVE' ? 'bg-[#ff0000]' : 'bg-[#9E120E]'}`}>
                                {match.updated_way === 'LIVE' ? 'LIVE' : match.match_result_text || 'Match Ended'}
                            </div>
                        </div> */}
                    </div>

                    <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                        {/* Team 1 */}
                        <div className="flex flex-col items-center gap-4 flex-1">
                            <img src={match.team1_school_image} alt={match.team1_name} className="w-[80px] h-[80px] object-contain" />
                            <h3 className="text-[18px] font-bold text-center text-[#231F20]">{match.team1_name}</h3>
                            <div className="text-center">
                                <p className="text-[24px] font-bold text-[#9E120E]">{match.team1_score_text || "Yet to Bat"}</p>
                            </div>
                        </div>

                        <div className="text-[#9E120E] font-bold text-[24px] italic">VS</div>

                        {/* Team 2 */}
                        <div className="flex flex-col items-center gap-4 flex-1">
                            <img src={match.team2_school_image} alt={match.team2_name} className="w-[80px] h-[80px] object-contain" />
                            <h3 className="text-[18px] font-bold text-center text-[#231F20]">{match.team2_name}</h3>
                            <div className="text-center">
                                <p className="text-[24px] font-bold text-[#9E120E]">{match.team2_score_text || "Yet to Bat"}</p>
                            </div>
                        </div>
                    </div>

                    <div className="text-center border-t pt-[16px]">
                        <h4 className="text-[#231F20] font-medium text-[16px]">{match.match_result_text}</h4>
                    </div>
                </div>



             {ifBigMatch ? (
                <div className="bg-white rounded-[12px] shadow-sm border border-gray-200 overflow-hidden">
    
                        <div className="px-[24px] py-[16px] border-b flex items-center justify-between gap-3">
                        <h3 className="text-[#231F20] font-bold text-[16px] md:text-[18px]">
                            Live Score
                        </h3>
                        </div>

                        {/* Responsive iframe */}
                        <div className="relative w-full pt-[140%] bg-gray-50">
                        <iframe
                            title="External Match View"
                            src={
                            match?.external_url ||
                            `https://matches.schoolscricket.lk/match/${match?.match_id}`
                            }
                            className="absolute top-0 left-0 w-full h-full"
                            loading="lazy"
                            referrerPolicy="no-referrer"
                            sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                            allow="fullscreen; autoplay; encrypted-media"
                        />
                        </div>

                    </div>
                    ) : (
                    <div></div>
                    )}      
                
                {/* Scorecards */}
                {ended_innings.map((inning, index) => (
                    <div key={inning.id} className="bg-white rounded-[12px] shadow-sm border border-gray-200 overflow-hidden">
                        <div className="bg-[#9E120E] px-[24px] py-[12px] text-white flex justify-between items-center">
                            <h3 className="font-bold text-[18px]">
                                Inning {inning.inning_no}: {inning.batting_team_name}
                            </h3>
                            <span className="text-[16px]">
                                {inning.score}/{inning.wickets} ({inning.overs} Ov)
                            </span>
                        </div>

                        <div className="p-[24px] flex flex-col gap-[24px]">

                            {/* Batting Table */}
                            <div>
                                <h4 className="font-bold text-[#231F20] mb-3 border-b pb-2">Batting</h4>
                                <div className="overflow-x-auto">
                                    <table className="w-full text-left text-[14px]">
                                        <thead className="bg-gray-50 text-gray-600 font-medium border-b">
                                            <tr>
                                                <th className="p-2">Batter</th>
                                                <th className="p-2">R</th>
                                                <th className="p-2">B</th>
                                                <th className="p-2">4s</th>
                                                <th className="p-2">6s</th>
                                                <th className="p-2">SR</th>
                                                <th className="p-2">Wicket</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y">
                                            {inning.batting.map((batter) => (
                                                <tr key={batter.id} className="hover:bg-gray-50">
                                                    <td className="p-2 font-medium text-[#231F20]">{batter.batsman_name}</td>
                                                    <td className="p-2 font-bold">{batter.runs}</td>
                                                    <td className="p-2 text-gray-600">{batter.balls}</td>
                                                    <td className="p-2 text-gray-600">{batter.fours}</td>
                                                    <td className="p-2 text-gray-600">{batter.sixes}</td>
                                                    <td className="p-2 text-gray-600">{batter.strike_rate}</td>
                                                    <td className="p-2 text-red-600 italic">{batter.out_description || "not out"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mt-2 text-[14px] text-gray-600">
                                    <strong>Extras:</strong> {inning.extras}
                                </div>
                            </div>

                            {/* Bowling Table */}
                            <div>
                                <h4 className="font-bold text-[#231F20] mb-3 border-b pb-2">Bowling</h4>
                                <div className="overflow-x-auto">
                                    <table className="w-full text-left text-[14px]">
                                        <thead className="bg-gray-50 text-gray-600 font-medium border-b">
                                            <tr>
                                                <th className="p-2">Bowler</th>
                                                <th className="p-2">O</th>
                                                <th className="p-2">M</th>
                                                <th className="p-2">R</th>
                                                <th className="p-2">W</th>
                                                <th className="p-2">Econ</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y">
                                            {inning.bowling.map((bowler) => (
                                                <tr key={bowler.id} className="hover:bg-gray-50">
                                                    <td className="p-2 font-medium text-[#231F20]">{bowler.bowler_name}</td>
                                                    <td className="p-2 text-gray-600">{bowler.overs}</td>
                                                    <td className="p-2 text-gray-600">{bowler.maidens}</td>
                                                    <td className="p-2 text-gray-600">{bowler.runs}</td>
                                                    <td className="p-2 font-bold">{bowler.wickets}</td>
                                                    <td className="p-2 text-gray-600">{bowler.economy}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Fall of Wickets */}
                            {inning.fall_of_wickets && (
                                <div className="bg-gray-50 p-4 rounded-md">
                                    <h4 className="font-bold text-[#231F20] mb-2 text-[14px]">Fall of Wickets</h4>
                                    <p className="text-[14px] text-gray-700 leading-relaxed">{inning.fall_of_wickets}</p>
                                </div>
                            )}

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ExternalMatchView;
